const BYTES_IN_KB = 1_024;
const BYTES_IN_MB = 1_048_576;

/**
 * Formats a size in BYTES for display. Every caller passes `File.size` /
 * `attachment.size`, which are byte counts.
 *
 * The previous implementation treated the input as bits (dividing by 8 for the
 * "B" branch), so anything under 1 KB rendered 8x too small.
 */
export default (fileSize = 0): string => {
  if (fileSize >= BYTES_IN_MB) {
    return `${(fileSize / BYTES_IN_MB).toFixed(1)} MB`;
  }

  if (fileSize >= BYTES_IN_KB) {
    return `${(fileSize / BYTES_IN_KB).toFixed(1)} KB`;
  }

  return `${fileSize} B`;
};
